import { FileUploadTemplate } from '@/components/FileUploadTemplate';
import { FC } from 'react';

export const Upload: FC = () => {
  return (
    <FileUploadTemplate
      title="Upload file"
      apiEndpoint="/upload"
      buttonText="Upload file"
      successMessage="Upload of the file was successful."
      validTitle="Upload"
    />
  );
};
